export const PREVIEW = 'preview';
export const EDIT = 'edit';
export const WHITE_LABEL = 'whiteLabel';
export const GENERIC_ACCESS = 'genericAccess';
export const DOCUMENT = 'document';
